import ENVIRONMENT_VARIABLES from '../environmentVariables';
export var onPressHelp = function onPressHelp() {
  var helpLink = "https://".concat(ENVIRONMENT_VARIABLES.HELP_LINK);
  var win = window.open(helpLink, '_blank');

  if (win != null) {
    win.focus();
  }
};